import classNames from 'classnames';
import React, { useState } from 'react';
import { useGetEmployees } from '../../redux/employee/hook';
import CollapsingIcon from '../collapsing-icon';
import { useEffect } from 'react';
import { employeeStatusConfig } from '../../utils/constants';
import { StatusText } from '../fragments/status-text';

const FormSelectEmployee = ({
  employee_status = -1,
  id,
  label,
  className,
  readOnly=false,
  value,
  empName,
  error,
  errorMessage,
  theme,
  setEmployee,
  inputRef,
  ...rest
}) => {
  const [text, setText] = useState('');
  const [search, setSearch] = useState('');
  const [showResults, setShowResult] = useState(false);

  const params = {
    limit: 10,
    page: 1,
    statusFilter: employee_status,
  };

  const { data: employees, status } = useGetEmployees(
    params.limit,
    params.page,
    params.statusFilter,
    search,
  );
  useEffect(() => {
    if (empName) {
      setText(empName);
    }
  }, [empName]);

  useEffect(() => {
    if (status === 'success' && search.trim()) {
      setShowResult(true);
    }
  }, [status, search]);

  function handleItemSelect(item) {
    setText(item.first_name + ' ' + item.last_name);
    setEmployee(item.id);
    setShowResult(false);
  }

  return (
    <>
      <div className='pb-[20px] flex flex-col'>
        <div className='flex w-full flex-col'>
          {label && (
            <label className='text-[18px] leading-[23px] font-normal text-color-gray'>
              {label}
            </label>
          )}
          <div>
            <div id='datalist'>
              <input
                id='datalist-input'
                type='text'
                autoComplete='off'
                ref={inputRef}
                readOnly={readOnly}
                onChange={(event) => {
                  setText(event.target.value);
                  setSearch(event.target.value);
                }}
                value={text}
                {...rest}
              />
              <i id='datalist-icon' className='icon iconfont'>
                <CollapsingIcon />
              </i>
              {/* Result List */}
              {employees && employees.data ? (
                <ul
                  className={classNames(
                    'datalist-items px-0 mt-2 rounded-sm border border-secondary-2 !z-[10000] bg-white',
                    {
                      hidden: employees.data.length === 0 || !showResults,
                    },
                  )}
                >
                  {employees.data.map((item) => (
                    <li
                      id={'12'}
                      className={`flex flex-row justify-between py-2 cursor-pointer
                       hover:bg-secondary-2
                        px-3 rounded-sm hover:text-white`}
                      onClick={() => handleItemSelect(item)}
                    >
                      <div className='flex flex-row items-center text-inherit'>
                        <span className='text-inherit'>{item.first_name}</span>
                        <span className='pl-2 text-inherit'>
                          {item.last_name}
                        </span>
                        <StatusText
                          code={item.status}
                          statusConfig={employeeStatusConfig}
                        />
                      </div>

                      <div className='text-inherit'>
                        <span className='text-inherit'>{item.mobile}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          </div>
        </div>
        {error && <span className='text-error'>* {errorMessage}</span>}
      </div>
    </>
  );
};

export default FormSelectEmployee;
